/**
 * DERS RENKLERİ — tek palet (sürüm 9a; belirteçler `tokens.css` `ders*` ailesi)
 *
 * Eski panelde iki ekran aynı derse iki renk veriyordu (tarama-2 §2.2). Burada ders adından
 * TEK yerde renk seçilir; ekranlar kendi `if`ini yazmaz. Sınıf adları TAM yazılı (Tailwind
 * birleştirilmiş adı tarayamaz). Ad eşleştirme Türkçe büyük/küçük harfe duyarsız ve KISMİ:
 * "TYT Matematik", "AYT Fizik", "T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK" gibi adlar tek kovaya düşer.
 */
export interface DersRengi {
  anahtar: "mat" | "tur" | "fen" | "sos" | "geo" | "den" | "ing" | "dig";
  /** Küçük renk noktası */
  nokta: string;
  /** Chip: açık zemin + koyu yazı */
  chip: string;
}

const PALET: Record<DersRengi["anahtar"], DersRengi> = {
  mat: { anahtar: "mat", nokta: "bg-dersmat-nokta", chip: "bg-dersmat-zemin text-dersmat-metin" },
  tur: { anahtar: "tur", nokta: "bg-derstur-nokta", chip: "bg-derstur-zemin text-derstur-metin" },
  fen: { anahtar: "fen", nokta: "bg-dersfen-nokta", chip: "bg-dersfen-zemin text-dersfen-metin" },
  sos: { anahtar: "sos", nokta: "bg-derssos-nokta", chip: "bg-derssos-zemin text-derssos-metin" },
  geo: { anahtar: "geo", nokta: "bg-dersgeo-nokta", chip: "bg-dersgeo-zemin text-dersgeo-metin" },
  den: { anahtar: "den", nokta: "bg-dersden-nokta", chip: "bg-dersden-zemin text-dersden-metin" },
  ing: { anahtar: "ing", nokta: "bg-dersing-nokta", chip: "bg-dersing-zemin text-dersing-metin" },
  dig: { anahtar: "dig", nokta: "bg-dersdig-nokta", chip: "bg-dersdig-zemin text-dersdig-metin" },
};

/** İlk eşleşen kazanır: "Genel Deneme" / "Branş Denemesi" dersin adını içerse bile deneme rengini alır, bu yüzden en üstte. */
const KURALLAR: readonly (readonly [RegExp, DersRengi["anahtar"]])[] = [
  [/deneme/, "den"],
  [/geometri/, "geo"],
  [/matematik/, "mat"],
  [/t[uü]rk[cç]e|edebiyat|dil ve anlat/, "tur"],
  [/fen|fizik|kimya|biyoloji/, "fen"],
  [/sosyal|tarih|inkılap|inkilap|co[gğ]rafya|felsefe|din k/, "sos"],
  [/ingiliz|yabancı dil|yabanci dil|almanca|fransızca/, "ing"],
];

export function dersRengi(ders: string): DersRengi {
  const ad = ders.toLocaleLowerCase("tr-TR");
  for (const [kalip, anahtar] of KURALLAR) if (kalip.test(ad)) return PALET[anahtar];
  return PALET.dig;
}
